import { Component, Input, OnInit, inject } from "@angular/core";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { FooterSocialNetwork } from "@hermes/api-model-shell";
import { LOCALE } from "@hermes/core-app-core";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

import { FooterClickEvent } from "../../events/click.event";
import { mapSocialIconToSVGs } from "../../helpers/social-icon.helper";

@Component({
    selector: "h-footer-social-networks-deprecated",
    imports: [SrOnlyNoSnippetDirective, SvgIconComponent],
    templateUrl: "./footer-social-networks-deprecated.component.html",
    styleUrls: ["./footer-social-networks-deprecated.component.scss"],
})
export class FooterSocialNetworksDeprecatedComponent implements OnInit {
    private locale = inject(LOCALE);
    private analyticsService = inject(AnalyticsService);

    protected readonly mapSocialIconToSVGs = mapSocialIconToSVGs;

    @Input({ required: true })
    public socialNetworks: FooterSocialNetwork[] = [];

    public weChatImageUrl!: string;
    public showWeChatTootip: boolean = false;

    public ngOnInit(): void {
        this.weChatImageUrl = `${this.locale.urlPrefix}/assets/images/qr-code-wechat.png`;
    }

    public handleClickOnSocialNetwork(
        $event: Event,
        socialNetworkLabel: string,
    ): void {
        $event.stopPropagation();

        this.analyticsService.sendData(
            new FooterClickEvent({
                action: "SocialNetworksIcons",
                label: socialNetworkLabel,
            }),
        );
    }

    public handleClickOnWechat(
        $event: Event,
        socialNetworkLabel: string,
    ): void {
        this.showWeChatTootip = true;

        this.handleClickOnSocialNetwork($event, socialNetworkLabel);
    }

    public hideWeChatTooltip(): void {
        this.showWeChatTootip = false;
    }

    public trackBySocialNetwork(
        index: number,
        socialNetwork: FooterSocialNetwork,
    ): string {
        return `${index}_${socialNetwork?.iconName}`;
    }
}
